var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSadBall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 87,
    height: 86,
    viewBox: "0 0 87 86",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.5 33C36.8807 33 38 34.1193 38 35.5V40.5H33V35.5C33 34.1193 34.1193 33 35.5 33Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.5 33C50.8807 33 52 34.1193 52 35.5V40.5H47V35.5C47 34.1193 48.1193 33 49.5 33Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.5 48.5C39.7386 48.5 37.5 50.7386 37.5 53.5H33.5C33.5 48.5294 37.5294 44.5 42.5 44.5C47.4706 44.5 51.5 48.5294 51.5 53.5H47.5C47.5 50.7386 45.2614 48.5 42.5 48.5Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43 69C57.3594 69 69 57.3594 69 43C69 28.6406 57.3594 17 43 17C28.6406 17 17 28.6406 17 43C17 57.3594 28.6406 69 43 69ZM43 73C59.5685 73 73 59.5685 73 43C73 26.4315 59.5685 13 43 13C26.4315 13 13 26.4315 13 43C13 59.5685 26.4315 73 43 73Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSadBall);
export default __webpack_public_path__ + "static/media/sadBall.16cea24f.svg";
export { ForwardRef as ReactComponent };